// packages/web/src/utils/algoliaInit.ts
// Web-specific Algolia initialization utility with static import

import { AlgoliaSearchService, algoliaConfig, validateAlgoliaConfig } from '@matchpoint/shared';
import { algoliasearch } from 'algoliasearch';

let isAlgoliaInitialized = false;

/**
 * Initialize Algolia service for web application using static import
 * This function should be called once during app startup
 */
export const initializeAlgoliaForWeb = async (): Promise<void> => {
  if (isAlgoliaInitialized) {
    return;
  }

  const hasAlgoliaKeys = algoliaConfig.appId && algoliaConfig.searchApiKey;
  
  try {

    // Create Algolia client directly in web package using proper import
    const algoliaClient = algoliasearch(algoliaConfig.appId, algoliaConfig.searchApiKey);
    
    // Try different method names that might exist
    let courtsIndex: any;
    const indexName = algoliaConfig.indices.courts;
    
    courtsIndex = {
    search: (query: string, params: any) => (algoliaClient as any).searchSingleIndex({
        indexName: indexName,
        searchParams: { query, ...params }
    }),
    indexName: indexName
    };

    console.log('Courts index created:', courtsIndex);
    
    if (!courtsIndex) {
      throw new Error('Could not create Algolia index - unknown API');
    }
    
    // Pass the initialized client to the service using the NEW method
    const algoliaService = AlgoliaSearchService.getInstance();
    algoliaService.initializeWithClient(algoliaClient, courtsIndex);
    
    isAlgoliaInitialized = true;
    console.log('✅ Algolia initialized successfully for web app (static import)');
  } catch (error) {
    console.error('❌ Failed to initialize Algolia for web app:', error);
    throw error;
  }
};

/**
 * Check if Algolia is initialized
 */
export const isAlgoliaReady = (): boolean => {
  return isAlgoliaInitialized;
};

/**
 * Reset initialization status (useful for testing)
 */
export const resetAlgoliaInitialization = (): void => {
  isAlgoliaInitialized = false;
};